module.exports = __webpack_public_path__ + "img/import.512eaa16.png";